/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {Injectable} from '@angular/core';
import {Observable, Subject} from 'rxjs';
import {MaterialListItemModel} from '../models/material-list-item.model';
import {SpecialOrderMaterialDetailModel} from '../../../api/ms-specialorders/contracts/special-order-material-detail.model';
import {MaterialValidateResultModel} from '../../../api/ms-specialorders/contracts/material-validate-result.model';
import {SpecialOrderPositionValidationResultModel} from '../../../api/ms-specialorders/contracts/special-order-position-validation-result.model';

@Injectable({
    providedIn: 'root'
})
export class MaterialListService {
    private materialDataSubject = new Subject<SpecialOrderMaterialDetailModel[]>();
    private materialNumbersSubject = new Subject<string[]>();
    private invalidMaterialsSubject = new Subject<MaterialValidateResultModel>();
    private supplyingPackingPlantCodeSubject = new Subject<string>();
    private materialHasWarningsSubject = new Subject<boolean>();
    private materialsErrorsSubject = new Subject<SpecialOrderPositionValidationResultModel[]>();
    private materialListHasErrorsSubject = new Subject<boolean>();

    get materialData(): Observable<SpecialOrderMaterialDetailModel[]> {
        return this.materialDataSubject.asObservable();
    }

    get materialNumbers(): Observable<string[]> {
        return this.materialNumbersSubject.asObservable();
    }

    get invalidMaterials(): Observable<MaterialValidateResultModel> {
        return this.invalidMaterialsSubject.asObservable();
    }

    get supplyingPackingPlantCode(): Observable<string> {
        return this.supplyingPackingPlantCodeSubject.asObservable();
    }

    get materialListHasWarnings(): Observable<boolean> {
        return this.materialHasWarningsSubject.asObservable();
    }

    get materialsErrors(): Observable<SpecialOrderPositionValidationResultModel[]> {
        return this.materialsErrorsSubject.asObservable();
    }

    get materialListHasErrors(): Observable<boolean> {
        return this.materialListHasErrorsSubject.asObservable();
    }

    refreshListItemData(materialsItems: MaterialListItemModel[]): void {
        this.materialDataSubject.next(materialsItems.map((materialItems) =>
                materialItems.detail));
    }

    refreshMaterialData(materialDetail: SpecialOrderMaterialDetailModel[]): void {
        this.materialDataSubject.next(materialDetail);
    }

    refreshMaterialNumbers(materialNumbers: string[]): void {
        this.materialNumbersSubject.next(materialNumbers);
    }

    refreshInvalidMaterials(invalidMaterials: MaterialValidateResultModel): void {
        this.invalidMaterialsSubject.next(invalidMaterials);
    }

    refreshSupplyingPackingPlantCode(code: string): void {
        this.supplyingPackingPlantCodeSubject.next(code);
    }

    refreshMaterialListHasWarnings(hasWarnings: boolean): void {
        this.materialHasWarningsSubject.next(hasWarnings);
    }

    refreshMaterialsErrors(report: SpecialOrderPositionValidationResultModel[]): void {
        this.materialsErrorsSubject.next(report);
    }

    refreshMaterialListHasErrors(hasErrors: boolean): void {
        this.materialListHasErrorsSubject.next(hasErrors);
    }
}

